/**
 * @components float-user
 * @author 陈恩浩
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs } from "antd";
import Login from "./components/login";
import Register from "./components/register";
import RetrievePassword from "./components/retrievePassword";
import TrialStudy from "./components/trialStudy";
import { changePopup } from "src/redux/basicInfo";
import { withTranslation } from "react-i18next";

import "./index.scss";
const { TabPane } = Tabs;

@withTranslation()
@connect((state) => state, { changePopup })
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (key) => {
    // console.log(key)
  };

  handleClose = () => {
    this.props.changePopup({ type: "", status: false });
  };

  render() {
    let { popupInfo } = this.props.basicInfo,
      { t } = this.props;

    return (
      popupInfo.status && (
        <div className="user-wrap">
          <div className="user">
            <div className="user-cloud"></div>
            <div className="user-close" onClick={this.handleClose}></div>
            <div className="user-inner">
              {(popupInfo.type === "login" ||
                popupInfo.type === "register") && (
                <Tabs
                  defaultActiveKey={popupInfo.type === "login" ? "2" : "1"}
                  onChange={this.handleChange}
                >
                  <TabPane tab={t("popout:login")} key="1">
                    <Register />
                  </TabPane>
                  <TabPane tab={t("popout:register")} key="2">
                    <Login />
                  </TabPane>
                </Tabs>
              )}
              {popupInfo.type === "retrieve" && <RetrievePassword />}
              {popupInfo.type === "trial" && (
                <TrialStudy history={this.props.history} />
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}

export default User;
